// extracted by mini-css-extract-plugin
export default {"container":"_b9SRBCv382mcrwwI3oS","body":"izlJe4Yrbx720vpVHUSp"};